import React from 'react';
import { Widget, Table, MasterDetailForm, FormInput, FormTextArea, ColumnProps, Row, Col } from '@digital/ui';
import { Collapse, Icon, Card, Divider } from 'antd';
import { CicloOrcamentarioProjetoDadosGerais } from '../../api/relatorioCicloorcamentario';

interface AbaGeralRelatorioCicloOrcamentarioProps {
  cicloOrcamentarioProjetoDadosGerais: CicloOrcamentarioProjetoDadosGerais;
}

const AbaGeralRelatorioCicloOrcamentario = (props: AbaGeralRelatorioCicloOrcamentarioProps) => {
  const { Panel } = Collapse;
  const { cicloOrcamentarioProjetoDadosGerais } = props;

  const collunsAnualEPlurianual: ColumnProps<any>[] = [
    {
      title: 'A',
      align: 'center',
      children: [
        {
          title: 'CapEx',
          align: 'center',
          dataIndex: 'capEx',
        },
      ],
    },
    {
      title: 'B',
      align: 'center',
      children: [
        {
          title: 'Contratado',
          align: 'center',
          dataIndex: 'contratado',
        },
      ],
    },
    {
      title: 'C',
      align: 'center',
      children: [
        {
          title: 'Executado',
          align: 'center',
          dataIndex: 'executado',
        },
      ],
    },
    {
      title: 'D',
      align: 'center',
      children: [
        {
          title: 'Requisitado',
          align: 'center',
          dataIndex: 'requisitado',
        },
      ],
    },
    {
      title: 'E = B - C + D',
      align: 'center',
      children: [
        {
          title: 'Compromissado',
          align: 'center',
          dataIndex: 'compromissado',
        },
      ],
    },
    {
      title: 'F',
      align: 'center',
      children: [
        {
          title: 'A Contratar',
          align: 'center',
          dataIndex: 'aContratar',
        },
      ],
    },
    {
      title: 'G = B + D + F',
      align: 'center',
      children: [
        {
          title: 'Forecast',
          align: 'center',
          dataIndex: 'forecast',
        },
      ],
    },
    {
      title: 'H = A - G',
      align: 'center',
      children: [
        {
          title: 'Saldo CapEx',
          align: 'center',
          dataIndex: 'saldoCapEx',
        },
      ],
    },
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['dadosgeraisform']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosgeraisform" header={<span>Dados Gerais</span>} style={{ border: 0 }}>
          <MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <FormInput label="Código" name="codigo" span={2} disabled />
            <FormInput label="Nome" name="nome" span={4} disabled />
            <FormInput label="Categoria" name="categoria" span={2} disabled />
            <FormInput label="Diretoria" name="diretoria" span={2} disabled />
            <FormInput label="Área" name="area" span={2} disabled />
            <FormInput label="Departamento" name="departamento" span={2} disabled />

            <FormInput label="Número TOTVS" name="totvs" span={2} disabled />
            <FormInput label="RFA" name="rfa" span={2} disabled />
            <FormInput label="Status RFA" name="statusRfa" span={2} disabled />

            <FormInput label="Data aprovação RFA" name="dataAprovacaoRfaFormatada" span={2} disabled />

            <FormTextArea label="Escopo" name="escopo" span={6} disabled rows={6} />
            <FormTextArea
              label="Requisitos Legais e Ambientais"
              name="requisitosAmbientais"
              span={6}
              disabled
              rows={6}
            />
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse
        bordered={false}
        defaultActiveKey={['DADOSCICLOORCAMENTARIO']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="DADOSCICLOORCAMENTARIO" header={<span>DADOS CICLO ORÇAMENTÁRIO</span>} style={{ border: 0 }}>
          <MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <FormInput label="TAP Atual" name="tapAtual" span={3} disabled />
            <FormInput label="Previsto" name="previsto" span={3} disabled />
            <FormTextArea label="Escopo TAP" name="escopoTab" span={12} disabled rows={6} />
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} defaultActiveKey={['relatorio']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="relatorio" header={<span>relatórios</span>} style={{ border: 0 }}>
          <MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <div className="cards-boletim-medicao">
              <Row>
                <Col span={2}>
                  <Card title="INÍCIO BASELINE (BL)" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioBaseline}
                  </Card>
                </Col>
                <Col span={2}>
                  <Card title="TÉRMINO BASELINE (BL)" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoBaseline}
                  </Card>
                </Col>
                <Col span={2}>
                  <Card title="Início real" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioReal}
                  </Card>
                </Col>
                <Col span={2}>
                  <Card title="Término real" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoReal}
                  </Card>
                </Col>
                <Col span={2}>
                  <Card title="Início Forecast" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioRealForecast}
                  </Card>
                </Col>
                <Col span={2}>
                  <Card title="Término Forecast" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoRealForecast}
                  </Card>
                </Col>
              </Row>
            </div>
            <Row>
              <Col>
                <fieldset>
                  <legend>PLUNIANUAL</legend>
                  <Table
                    dataSource={cicloOrcamentarioProjetoDadosGerais.pluriAnual}
                    columns={collunsAnualEPlurianual}
                    pagination={false}
                  />
                </fieldset>
                <fieldset>
                  <legend>Anual</legend>
                  <Table
                    dataSource={cicloOrcamentarioProjetoDadosGerais.anual}
                    columns={collunsAnualEPlurianual}
                    pagination={false}
                  />
                </fieldset>
              </Col>
            </Row>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default AbaGeralRelatorioCicloOrcamentario;
